import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M12 3.75a8.25 8.25 0 100 16.5 8.25 8.25 0 000-16.5zm3.016 6.688L11.19 14.25a.488.488 0 01-.688 0l-1.514-1.514a.485.485 0 01.023-.71l.011-.01a.488.488 0 01.667.023l1.159 1.17 3.481-3.46a.488.488 0 01.687.691z"
}), 'CheckRoundFilled');